import Vue from 'vue';
import { mapState } from 'vuex';
import store from 'store';

export default (el) =>
  new Vue({
    el,
    store,
    data() {
      return {
        observer: null,
      };
    },
    mounted() {
      const yotpoPicturesWidget = this.$refs.yotpoPicturesWidget;
      this.initObserver(yotpoPicturesWidget);
    },
    computed: {
      ...mapState('global', ['UGC']),
    },
    methods: {
      initObserver(yotpoPicturesWidget) {
        const vm = this;
        const config = {
          attributes: false,
          childList: true,
          subtree: true,
        };

        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'childList') {
              if (mutation.target.children.length) {
                vm.$store.commit('global/setUGCSliderExistance');
              }
              observer.disconnect();
            }
          });
        });

        observer.observe(yotpoPicturesWidget, config);
        this.observer = observer;
      },
    },
  });
